import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "card-toolbar" }
const _hoisted_8 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_9 = {
  type: "button",
  class: "btn btn-light-primary me-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_call_out_record_import"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = { class: "svg-icon svg-icon-2" }
const _hoisted_12 = { class: "me-0" }
const _hoisted_13 = {
  class: "btn btn-icon btn-bg-light btn-active-color-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_14 = {
  key: 0,
  class: "spinner-border spinner-border-sm text-primary align-middle"
}
const _hoisted_15 = {
  key: 1,
  class: "bi bi-three-dots fs-3"
}
const _hoisted_16 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold w-300px",
  "data-kt-menu": "true"
}
const _hoisted_17 = { class: "menu-item px-3" }
const _hoisted_18 = { class: "menu-content fs-6 text-gray-400 px-3 py-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_20 = { class: "menu-item px-3" }
const _hoisted_21 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_22 = { class: "menu-item px-3" }
const _hoisted_23 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 opacity-75" }, null, -1)
const _hoisted_25 = { class: "card-body pt-0" }
const _hoisted_26 = { class: "mw-100px" }
const _hoisted_27 = { class: "mw-150px" }
const _hoisted_28 = { class: "mw-100px" }
const _hoisted_29 = ["title", "onClick"]
const _hoisted_30 = { class: "svg-icon svg-icon-3" }
const _hoisted_31 = ["title", "onClick"]
const _hoisted_32 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_MBDatatable = _resolveComponent("MBDatatable")!
  const _component_AddHsCodeModal = _resolveComponent("AddHsCodeModal")!
  const _component_viewHsCodeLogModal = _resolveComponent("viewHsCodeLogModal")!
  const _component_HsCodeImportModal = _resolveComponent("HsCodeImportModal")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
              class: "form-control form-control-solid w-250px ps-14",
              placeholder: _ctx.t('common.search')
            }, null, 40, _hoisted_6), [
              [_vModelText, _ctx.search]
            ]),
            _withDirectives(_createElementVNode("span", {
              class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle",
              style: {"cursor":"pointer"},
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
            }, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ], 512), [
              [_vShow, _ctx.search != '']
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil017.svg" })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.import")), 1)
            ])), [
              [_directive_auth, { auth: ['import'] }]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", {
              type: "button",
              class: "btn btn-primary me-3",
              "data-bs-toggle": "modal",
              "data-bs-target": "#modal_add_hs_code",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onAddButtonClick && _ctx.onAddButtonClick(...args)))
            }, [
              _createElementVNode("span", _hoisted_11, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.t("hsCodeManagement.addHsCode")), 1)
            ])), [
              [_directive_auth, { auth: ['add'] }]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("button", _hoisted_13, [
                (_ctx.disabledExport || _ctx.disabledExportLog)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                  : (_openBlock(), _createElementBlock("i", _hoisted_15))
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.t("common.export")), 1)
                ]),
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["menu-link px-3", {
                    'opacity-50': _ctx.disabledExport,
                    'cursor-nodrop': _ctx.disabledExport,
                  }]),
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fileExport && _ctx.fileExport(...args)))
                  }, [
                    (_ctx.disabledExport)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("hsCodeManagement.exportHsCode")), 1)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["menu-link px-3", {
                    'opacity-50': _ctx.disabledExportLog,
                    'cursor-nodrop': _ctx.disabledExportLog,
                  }]),
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.fileExportLog && _ctx.fileExportLog(...args)))
                  }, [
                    (_ctx.disabledExportLog)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("hsCodeManagement.exportHsCodeLog")), 1)
                  ], 2)
                ]),
                _hoisted_24
              ])
            ])), [
              [_directive_auth, { auth: ['export'] }]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_MBDatatable, {
          loading: _ctx.loading,
          "table-data": _ctx.tableData,
          "table-header": _ctx.tableHeader,
          order: "desc",
          "enable-items-per-page-dropdown": true,
          "current-page": _ctx.currentPage,
          total: _ctx.total,
          "rows-per-page": _ctx.pageSize,
          onCurrentChange: _ctx.onCurrentPageChange,
          onItemsPerPageChange: _ctx.onRowsPerPageChange,
          onSort: _ctx.onColumnSort
        }, {
          "cell-brand_name": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.brand_name), 1)
          ]),
          "cell-brand_article_no": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.brand_article_no), 1)
          ]),
          "cell-name": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_26, _toDisplayString(item.category + ", " + item.sex + ", " + item.color), 1)
          ]),
          "cell-material": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_27, _toDisplayString(item.material), 1)
          ]),
          "cell-make_in": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.make_in), 1)
          ]),
          "cell-hs_code": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.hs_code), 1)
          ]),
          "cell-updated_at": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.formatDateTime(item.updated_at)), 1)
          ]),
          "cell-actions": _withCtx(({ row: item }) => [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-3",
              title: _ctx.t('common.edit'),
              "data-bs-toggle": "modal",
              "data-bs-target": "#modal_add_hs_code",
              onClick: ($event: any) => (_ctx.onEditButtonClick(item.id))
            }, [
              _createElementVNode("span", _hoisted_30, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
              ])
            ], 8, _hoisted_29)), [
              [_directive_auth, { auth: ['update'] }]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary",
              title: _ctx.t('hsCodeManagement.viewUpdateLog'),
              "data-bs-toggle": "modal",
              "data-bs-target": "#modal_view_hs_code",
              onClick: ($event: any) => (_ctx.onViewButtonClick(item.id))
            }, [
              _createElementVNode("span", _hoisted_32, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen004.svg" })
              ])
            ], 8, _hoisted_31)
          ]),
          _: 1
        }, 8, ["loading", "table-data", "table-header", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange", "onSort"])
      ])
    ]),
    _createVNode(_component_AddHsCodeModal, {
      id: _ctx.editId,
      onUpdateList: _ctx.updateList
    }, null, 8, ["id", "onUpdateList"]),
    _createVNode(_component_viewHsCodeLogModal, { id: _ctx.viewId }, null, 8, ["id"]),
    _createVNode(_component_HsCodeImportModal, { onUpdateList: _ctx.updateList }, null, 8, ["onUpdateList"])
  ], 64))
}